import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Loading } from "components/Loading";
import { getResponse } from "store";

export const ContainerPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getResponse(null));
  }, [dispatch]);

  return <Loading />;
};
